import React, { Component } from 'react';
import MenuIcon from './MenuIcon';
import Filter from './Filter';

export default class PageHeader extends Component {
    render () {
        let props = this.props.pageHeaderProps;
        return (
            <div className="header-wrapper">
                <div className="header">
                    <MenuIcon showNavBar = {props.showNavBar} handleNavBar={this.handleNavBar}/>
                    <div className="dashboard-title">
                        <p onClick={()=> {this.handleThemeChange()}}>GREENWAY CARRIERS</p>
                    </div>
                    <div className="filter-container">
                    <Filter timeSelectorValue={props.timeSelectorValue} handleFilterDropdown={props.handleFilterDropdown} handleDataChange={props.handleDataChange} handleAllShipperData={props.handleAllShipperData}/>
                    </div>
                </div>
            </div>
        );
    }
    /**
     * function to handle navBar display.
     * when Menu Icon is clicked display of navbar is toggled
     */
    handleNavBar = () => {
        let props = this.props.pageHeaderProps;
        props.handleNavBar(!props.showNavBar);
    }
    /**
     * function to switch themes.
     * To be scoped in future.
     */
    handleThemeChange = ()=> {
        let props = this.props.pageHeaderProps,
        theme = (props.theme === 'dark') ? 'light' : 'dark';
        props.handleTheme(theme);
    }

}


// WEBPACK FOOTER //
// ./src/components/PageHeader.js